<template>
  <base-modal
    id="camera-selector"
    ref="camera-selector"
    size="modal-md"
    :show="showCameraSelector"
    :show-close-button="false"
    title="Select your Camera"
  >
    <select-camera-modal
      @stream="(stream) => $emit('stream', stream)"
      @close-modal="$emit('closed')"
    />
  </base-modal>
</template>

<script>
import SelectCameraModal from './SelectCameraModal';

export default {
  name: 'SelectCameraModalContainer',
  components: {
    SelectCameraModal,
  },
  props: {
    showCameraSelector: {
      default: false,
      type: Boolean,
    },
  },
};
</script>

<style>

</style>
